module.exports = __webpack_public_path__ + "static/img/icon-shine.3f15d34.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/icon-shine.png
// module id = cxEj
// module chunks = 1